import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { goddivaInvoiceReportApi, exportInvoiceRowApi, uploadInvoiceToXeroApi } from "../../../../services/report";

export const getSalesInvoiceReportData = createAsyncThunk(
    'report/sales-invoice-report',
    async (data, { dispatch }) => {
        const response = await goddivaInvoiceReportApi(data);
        dispatch(setTableRowCount(response.length));
        const responseData = response;
        console.log(response);
        const items = Array.isArray(responseData) ? responseData : (responseData.results || responseData.data || []);
        const count = !Array.isArray(responseData) && responseData.count !== undefined ? responseData.count : items.length;
        dispatch(setTableRowCount(count));
        return items;
    }
);

export const exportInvoiceDetailReport = createAsyncThunk('report/exportInvoiceDetailReport', async (invoiceId, { dispatch }) => {
    const response = await exportInvoiceRowApi(invoiceId);
    console.log('Export response:', response);
    return response;
});

export const handleXeroUpload = createAsyncThunk('report/handleXeroUpload', async (data, { dispatch }) => {
    const response = await uploadInvoiceToXeroApi(data);
    return response;
});


const salesInvoiceAdapter = createEntityAdapter({});

export const {
    selectAll: selectSalesInvoiceReport,
    selectById: selectSalesInvoiceReportById
} = salesInvoiceAdapter.getSelectors(
    state => state.report.salesInvoiceReport
);

const salesInvoiceReportSlice = createSlice({
    name: 'salesInvoiceReport',
    initialState: salesInvoiceAdapter.getInitialState({
        id: null,
        salesInvoiceTableRow: 0
    }),

    reducers: {
        setTableRowCount: (state, action) => {
            state.salesInvoiceTableRow = action.payload;
        },
    //     setTotalAmount: (state, action) => {
    //         state.totalAmount = action.payload;
    //     },
    },

    extraReducers: {
        [getSalesInvoiceReportData.fulfilled]: salesInvoiceAdapter.setAll
    }
});

export const { setTableRowCount} = salesInvoiceReportSlice.actions;

export default salesInvoiceReportSlice.reducer;